import type { ResourcesContent } from "../types";

export const resources: ResourcesContent = {
  title: "Read, learn, explore.",
  lead: "The launch story, the documentation, and the Danish models in the making.",
  cards: [
    {
      tag: "Director's note · Launch",
      title: "Why we built UCloud AI",
      excerpt:
        "Danish research data leaves the country every day through foreign chat windows and APIs. With UCloud AI, it doesn't have to. Every token is computed in Denmark, inside the national platform you already trust, and your research is never training data. Sovereignty is not a slogan, it is a login you already have.",
      meta: "Prof. Claudio Pica · SDU eScience Center",
    },
    {
      tag: "Documentation",
      title: "From login to first token in five minutes",
      excerpt:
        "Log in with your university ID, pick a model, and call the OpenAI-compatible API from inside your project. The walkthrough, end to end.",
      meta: "Updated Sep 2026",
    },
    {
      tag: "Danish Foundation Models",
      title: "Building the foundation of Danish AI",
      excerpt:
        "Language models have become critical infrastructure, and smaller languages like Danish risk being left behind. DFM is the national collaboration on open Danish AI, trained on UCloud and coming to the catalog.",
      meta: "foundationmodels.dk",
    },
  ],
};
